<template>
  <div class="cartShop" v-if="cartTotalqty>0">
    <!-- <b-button v-b-toggle.sidebar-right>Toggle Sidebar</b-button> -->
    <b-sidebar id="cartShop" :title="'My Shop ('+cartTotalqty+')'" right :backdrop-variant="variant" backdrop shadow>
		<b-container fluid>		
			
			<!-- {{cartItems}} -->
			<div class="card" :key="item.id" v-for="item in cartItems">
				<!-- <header class="card-header">featured</header> -->
				<div class="card-body">
					<b-row>
						<b-col cols="3" sm="3" md="3" lg="3">
							<b-link :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
						</b-col>
						<b-col cols="7" sm="7" md="7" lg="7">							
							<span class="pTitle">{{item.title}}</span>
							<p class="pTitle"><small>{{item.short_description}}</small></p>
						</b-col>
						<b-col cols="1" sm="2" md="1" lg="1">
							<b-link @click="$root.removeShare(item)"><i class="fa fa-trash" aria-hidden="true"></i></b-link>
						</b-col >
					</b-row>
					
				</div>
				<footer class="card-footer">						
					<b-row>
							<b-col>
								<small>Commission: </small> {{item.commission}}%
							</b-col>
							<b-col class="text-right" >
								<span v-if="item.special_price>0 && item.special_price!=null">
							 <del class="spCross">{{$root.currency()+$root.tofixed((item.price ), 2)}}</del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price), 2)}}</small>
						   
							</span>
							<span v-else>
									<small class="my-0" >{{$root.currency()+$root.tofixed((item.price), 2)}}</small>
							</span>

							<!--<small v-if="item.special_price>0 && item.special_price!=null">
							 {{$root.currency()+$root.tofixed((item.special_price * item.qty), 2)}}</small>
							<small  v-else >{{$root.currency()+$root.tofixed((item.price * item.qty), 2)}}</small> -->
							</b-col>
						</b-row>
				</footer>
			</div>

			
		</b-container>
		<!-- <template #header="{ hide }">
       <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">header</strong>
        <b-button size="sm" @click="hide">Close</b-button>
       </div>
      </template>-->
      
	   <template #footer="{ hide }">
       <div class="d-flex footerBg align-items-center mb-2">
       	  <!-- <div class="d-flex footerBg bg-dark text-light align-items-center px-3 "> -->
       	<b-container fluid>
	       	<b-row>
	       		<!-- <b-col 	cols="6"	 sm="6"	md="6"	lg="6"	xl="6" style="padding-top: 12px; text-align:center;">	       			
	       			 <b-link @click="$root.shareProduct(),$root.share.iamiconfor='allnetwork'" ><span class="totalPr">Share Now</span></b-link>
	       		</b-col> -->
				<b-col v-if="cartTotalqty>4" cols="12" sm="12"	md="12"	lg="12"	xl="12" class="checkoutBg text-center">
	       				<b-link class="btn-solid2 btn3" @click="$root.shareProductLater(),hide" v-b-popover.hover.top="'You’ll be redirected to My Shop page. You can create list and share from My Shop page.'" title="More than 4 products in the list." >Share Now</b-link>
	       				<!--<b-link class="btn-solid2 btn3" @click="$root.shareProductLater(),hide" >Share Later</b-link> -->
	       		
	       		</b-col>
				<b-col v-else cols="12" sm="12"	md="12"	lg="12"	xl="12" class="checkoutBg text-center">	 
					<b-link class="btn-solid2 btn3" @click="$root.shareProductwithshop(),$root.share.iamiconfor='allnetwork'" >Share Now </b-link>
	       		</b-col> 
	       		
	        </b-row>
    	</b-container>
       </div>
      </template>
    </b-sidebar>
	
  </div>
</template>
<script>
import '@/assets/cartShop.scss';
export default {
  name: 'CartShop',
  components: {
 
  },
  props: {
    cartItems: { type: Array },
    cartData: { type: Array  },
	cartTotalqty:Number,
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      modaldata_qty: 1,
	  variant:'dark',
	  cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">




</style>
